import { createDevextremeDatasource } from '@/letapps-vue/utils/useRestApi';

let store;

export function getPengeinstitutDatasource() {
  if (!store) {
    store = createDevextremeDatasource('/api/Pengeinstitutter', 'id', {
      paginate: false,
    });
  }

  return store;
}
